<div class="content-wrapper-inner">
  <div class="page-content">
    <div [hidden]="!loading" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <h1 class="main-title">Billing</h1>
    <ng-container>
      <h2 class="subtitle">Current plan</h2>
      <div class="current-plan card">
        <div class="current-balance"><span class="pointer" [tooltip]="'Current balance'" tooltipPlacement="top">€{{ currentBalance }}</span> <span
            *ngIf="currentPlan" class="available-tests">up to {{ currentPlan.availableTests }} tests available</span></div>
        <app-billing-progress *ngIf="progress" [total]="progress.total" [current]="progress.current" [parts]="progress.parts"
          [counters]="false"></app-billing-progress>
        <hr />
        <div class="text-muted">
          You will see a separate bar showing the balance left for every active package that you purchase. <br>If you see 2 bars, you still have some credits
          remaining from your previous purchase.<br>
          If you are seeing only 1 bar, this means that all the credits from your previous top up are spent and you have 1 active package.
        </div>
      </div>
    </ng-container>
    <h2 class="subtitle">Upgrade plan</h2>
    <div class="pricing-plans">
      <div *ngFor="let item of models" class="pricing-plan card" [ngClass]="idsActive.includes(item.id) ? 'active' : ''">
        <span *ngIf="idsActive.includes(item.id)" class="badge badge-primary badge-active">Active</span>
        <h2 class="title">{{ item.title }}</h2>
        <div class="body">
          <ul *ngFor="let bundle of item.bundles" class="bundle">
            <li class="service">
              <span class="gray">{{ getFullNameServiceType(bundle.serviceType) }} -</span> €{{ bundle.ratePerUnit }} per test
            </li>
            <li class="credit-validity gray">
              {{ bundle.creditValidity }} credit validity
            </li>
            <li *ngIf="bundle.offerVisibleUntil" class="visible-until">
              <span class="gray">Offer visible until</span> {{ bundle.offerVisibleUntil | date:'mediumDate' }}
            </li>
          </ul>
        </div>
        <div class="footer">
          <div class="commitment">
            <h1>€{{ item.totalCommitment }}</h1>
          </div>
          <button [disabled]="!user.enabled" (click)="onSelectPricingGroup(item.id)" class="btn top-up">Top-up</button>
        </div>
      </div>
    </div>
  </div>
  <div class="alert alert-primary mt-20">
    <div class="description">
      For more information about billing, please contact your account manager. <br>
      <a class="text-primary-p8" *ngIf="user?.ownerEmail" [href]="'mailto:' + user?.ownerEmail" target="_blank"
        rel="noopener noreferrer">{{user?.ownerEmail}}</a>
      <a class="text-primary-p8" *ngIf="!user?.ownerEmail" href="mailto:sales@telqtele.com" target="_blank" rel="noopener noreferrer">sales&#64;telqtele.com</a>
    </div>
  </div>
</div>
